import { render, staticRenderFns } from "./base-popover.vue?vue&type=template&id=6535ffa0"
import script from "./base-popover.vue?vue&type=script&lang=js"
export * from "./base-popover.vue?vue&type=script&lang=js"
import style0 from "./base-popover.vue?vue&type=style&index=0&id=6535ffa0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports